import type {AddComponentTypeOptions, ComponentDefinition, ComponentDefinitionDefined} from 'grapesjs';
import {FORM_ASTERISK_STYLES} from './component-styles';
import {safeElement} from './safe-element';

export interface BaseBoxComponentArgs {
  boxType: string;
  /** Marker attribute name, e.g. 'data-is-pmw-form-email-box'. */
  dataMarkerAttribute: string;
  components: ComponentDefinition[];
  style?: object | string;
}

export function createBaseBoxComponent(args: BaseBoxComponentArgs): AddComponentTypeOptions {
  const {boxType, dataMarkerAttribute, components, style = ''} = args;
  return {
    model: {
      defaults: {
        tagName: 'div',
        highlightable: false,
        hoverable: false,
        selectable: false,
        badgable: false,
        droppable: false,
        draggable: false,
        copyable: false,
        editable: false,
        removable: false,
        toolbar: [],
        style,
        components,
        attributes: {
          'data-pmw-type': boxType,
          [dataMarkerAttribute]: '1',
        },
      },
    },
    isComponent: (el: Element): boolean | ComponentDefinitionDefined => {
      if (!safeElement(el)) {
        return false;
      }
      if (el.tagName === 'DIV' && el.getAttribute(dataMarkerAttribute) !== null) {
        return {type: boxType} as ComponentDefinitionDefined;
      }
      return false;
    },
  };
}

// The empty span must always be emitted; runtime JS toggles the asterisk character into .js-asterisk-required.
export function asteriskHtml(defaultRequired = false): string {
  const asterisk = defaultRequired ? '*' : '';
  return `<span class="js-asterisk-required" style="${FORM_ASTERISK_STYLES}">${asterisk}</span>`;
}
